import React, { useEffect, useState } from 'react'
import { Row, Col, Table, Typography } from 'antd'

const ContainerDetails = (props) => {
  const containerCol = [
    {
      title: 'Container type',
      dataIndex: 'uld_type',
      key: 'uld_type',
      align: 'left',
      className: 'checklist-cols'
    },
    {
      title: 'Est. Conv Weight',
      dataIndex: 'wgt',
      key: 'wgt',
      align: 'left',
      className: 'checklist-cols',
      render: (_, record) => {
        if (props.wgt_unit === 'KG') {
          // lb to kg
          return Math.round(record.wgt * 0.453592)
        }
        return Math.round(record.wgt)
      }
    },
    {
      title: 'Priority',
      dataIndex: 'remark',
      key: 'remark',
      align: 'left',
      className: 'checklist-cols'
    }
  ]

  const bagColumns = [
    {
      title: 'Bag Positions',
      dataIndex: 'positions',
      key: 'positions',
      align: 'left',
      className: 'checklist-cols'
    },
    {
      title: 'Bulk Bags',
      dataIndex: 'bulk',
      key: 'bulk',
      align: 'left',
      className: 'checklist-cols'
    }
  ]

  const getData = () => {
    let tare = 0
    if ([333, 333, 339, 359].includes(props.data?.fleet_type)) {
      tare = props.wgt_unit === 'KG' ? 82 : 181
    } else {
      tare = props.wgt_unit === 'KG' ? 92 : 203
    }
    let bag_pos_wgt = props.data?.bag_pos_wgt || 0
    let bulk_bag_wgt = props.data?.bulk_bag_wgt || 0
    if (props.wgt_unit === 'KG') {
      // lb to kg conversion
      bag_pos_wgt = bag_pos_wgt * 0.453592
      bulk_bag_wgt = bulk_bag_wgt * 0.453592
    }
    bag_pos_wgt = Math.round((bag_pos_wgt + tare) / 10) * 10 // round to nearest 10
    bulk_bag_wgt = Math.round(bulk_bag_wgt)
    return [
      {
        key: '1',
        positions: props.data?.bag_pos || 0,
        bulk: props.data?.bulk_bag || 0
      },
      {
        key: '2',
        // positions: `${props?.data?.bag_pos_wgt || 0} lbs per pos`,
        positions: `${bag_pos_wgt} ${props.wgt_unit?.toLowerCase() === 'kg' ? 'kg' : 'lbs'} per pos`,
        // bulk: `${props?.data?.bulk_bag_wgt || 0} lbs`
        bulk: `${bulk_bag_wgt} ${props.wgt_unit?.toLowerCase() === 'kg' ? 'kg' : 'lbs'}`
      }
    ]
  }

  const { pallet_uld = {}, pallet = {}, cargo_uld = {}, cargo = {} } = props.data?.position || {}

  // use state to keep track of excluded keys
  const [ids, setIds] = useState([])


  useEffect(() => {
    getHiglightedRows()
  }, [props.ulds])

  const getHiglightedRows = () => {
    let excludedKeys = []
    setIds([])
    let ld2 = ['DPA', 'DPE', 'DPL', 'DPN']
    let ld3 = ['AKE', 'AKN', 'AKX', 'AKY']
    props.ulds.forEach((record) => {
      for (const key of Object.keys(pallet_uld)) {
        if (
          pallet_uld[key] === record.uld_type?.substring(0, 3) &&
          Math.round(parseFloat(pallet[key])) === Math.round(parseFloat(record.wgt)) &&
          !excludedKeys.includes(key)
        ) {
          excludedKeys.push(key)
          setIds((prevIds) => [...prevIds, record.id])
          return
        }
      }
      for (const key of Object.keys(cargo_uld)) {
        if (key.includes('l')) {
          if (
            cargo_uld[key] === record.uld_type?.substring(0, 3) &&
            Math.round(parseFloat(cargo[key])) === Math.round(parseFloat(record.wgt)) &&
            !excludedKeys.includes(key)
          ) {
            excludedKeys.push(key)
            setIds((prevIds) => [...prevIds, record.id])
            return
          }
          if (cargo_uld[key] == 'LD2' && ld2.includes(record.uld_type?.substring(0, 3)) &&
            Math.round(parseFloat(cargo[key])) === Math.round(parseFloat(record.wgt)) &&
            !excludedKeys.includes(key)
          ) {
            excludedKeys.push(key)
            setIds((prevIds) => [...prevIds, record.id])
            return
          }
          if (cargo_uld[key] == 'LD3' && ld3.includes(record.uld_type?.substring(0, 3)) &&
            Math.round(parseFloat(cargo[key])) === Math.round(parseFloat(record.wgt)) &&
            !excludedKeys.includes(key)
          ) {
            excludedKeys.push(key)
            setIds((prevIds) => [...prevIds, record.id])
            return
          }
        }
      }
      for (const key of Object.keys(cargo_uld)) {
        let index = parseInt(key.replace(/\D/g, ''), 10)
        if (key.includes('l')) {
          let key2 = 'r' + index
          if (
            cargo_uld[key] === record.uld_type?.substring(0, 3) &&
            Math.round(parseFloat(cargo[key2])) === Math.round(parseFloat(record.wgt)) &&
            !excludedKeys.includes(key2)
          ) {
            excludedKeys.push(key2)
            setIds((prevIds) => [...prevIds, record.id])
            return
          }
          if (cargo_uld[key] == 'LD2' && ld2.includes(record.uld_type?.substring(0, 3)) &&
            Math.round(parseFloat(cargo[key2])) === Math.round(parseFloat(record.wgt)) &&
            !excludedKeys.includes(key2)
          ) {
            excludedKeys.push(key2)
            setIds((prevIds) => [...prevIds, record.id])
            return
          }
          if (cargo_uld[key] == 'LD3' && ld3.includes(record.uld_type?.substring(0, 3)) &&
            Math.round(parseFloat(cargo[key2])) === Math.round(parseFloat(record.wgt)) &&
            !excludedKeys.includes(key2)
          ) {
            excludedKeys.push(key2)
            setIds((prevIds) => [...prevIds, record.id])
            return
          }
        }
      }
    })
  }


  const rowClassName = (record) => {
    return ids.includes(record.id) ? 'highlight-row' : ''
  }

  return (
    <Row className='wb-tables' gutter={[32, 0]}>
      <Col xs={24} sm={24} md={{
        span: 10,
        offset: 0 
      }}
      lg={{
        span: 7,
        offset: 3
      }}
      >
        <Typography.Text level={5} className='WnB-table-title'>Estimated Bags</Typography.Text>
        <Table
          className='WnB-table'
          columns={bagColumns}
          dataSource={getData()}
          pagination={false}
        />
      </Col>
      <Col xs={24} sm={24} md={{
        span: 12,
        offset: 1 
      }}
      lg={{
        span: 10,
        offset: 2
      }}>
        <Typography.Text level={5} className='WnB-table-title'>Containers in Staging</Typography.Text>
        <Table
          className='WnB-table'
          dataSource={props.ulds}
          pagination={false}
          columns={containerCol}
          rowClassName={rowClassName}
        />
      </Col>
    </Row>
  )
}

export default ContainerDetails